import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { StudiesService } from '../../../services/studies/studies.service';
import { Study } from '../../../types';
import { StudyHistoryTable } from '../../../services/studies/utils/study-history-table';

@Component({
  selector: 'app-study-history-page',
  styleUrls: ['./study-history-page.component.scss'],
  templateUrl: './study-history-page.component.html',
})
export class StudyHistoryPageComponent implements OnInit {
  study: Study;
  errorMessage: string;
  studyHistoryTable: StudyHistoryTable;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private studiesService: StudiesService,
  ) {}

  async ngOnInit() {
    const studyId = Number(this.route.parent.snapshot.params['id']);
    this.loading = true;

    const { data, error } =
      await this.studiesService.getStudyWithHistory(studyId);

    this.study = data?.study;
    this.loading = false;
    this.errorMessage = error?.message || '';

    this.studyHistoryTable =
      data?.documents && new StudyHistoryTable(data.documents);
  }
}
